import React from 'react';
import { getTheme } from '@uifabric/styling';
import { ActionIconName, Icon } from '../../../Icons';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const CollapseTools = props => {
  const buttonStyle = {
    zIndex: 2,
    cursor: 'pointer',
    color: getTheme().palette.themePrimary,
    fontWeight: 600,
    marginTop: 3
  };
  if (props.customCollapseTool) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: props.customCollapseTool
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: props.column.isExpanded ? /*#__PURE__*/_jsx(Icon, {
      "data-id": "collapse-".concat(props.column.originalId),
      iconName: ActionIconName.Minus,
      styles: {
        root: buttonStyle
      },
      onClick: () => {
        props.changeCollapsing(props.column.originalId);
      }
    }) : /*#__PURE__*/_jsx(Icon, {
      "data-id": "expand-".concat(props.column.originalId),
      iconName: ActionIconName.Plus,
      styles: {
        root: buttonStyle
      },
      onClick: () => {
        props.changeCollapsing(props.column.originalId);
      }
    })
  });
};